import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * GlobalBackBar
 * A single, consistent in-app back control rendered on every route except home.
 * Keeps navigation inside the SPA (history-based) instead of opening new tabs.
 */
const HIDDEN_ROUTES = ['/'];

const GlobalBackBar = React.memo(function GlobalBackBar() {
  const location = useLocation();
  const navigate = useNavigate();

  if (HIDDEN_ROUTES.includes(location.pathname)) return null;

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      // Intelligent fallback for deep links
      if (location.pathname.startsWith('/hostel/')) {
        navigate('/search');
      } else if (location.pathname.startsWith('/landlord-dashboard') && location.pathname !== '/landlord-dashboard') {
        navigate('/landlord-dashboard');
      } else if (location.pathname.startsWith('/student-dashboard') && location.pathname !== '/student-dashboard') {
        navigate('/student-dashboard');
      } else {
        navigate('/');
      }
    }
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label="Go back to the previous page"
      className="fixed left-4 top-[4.75rem] z-40 inline-flex items-center gap-1.5 rounded-lg border border-border bg-card px-3 py-2 text-sm font-medium text-foreground shadow-soft transition-colors hover:bg-secondary min-h-touch focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <ArrowLeft className="h-4 w-4" />
      <span>Back</span>
    </button>
  );
});

GlobalBackBar.displayName = 'GlobalBackBar';

export default GlobalBackBar;
